module.exports = __webpack_public_path__ + "img/22.f4e768de.png";